import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {ModalModule} from 'ngx-bootstrap/modal';
import {TranslateModule} from "@ngx-translate/core";
import {AuthSideNavComponent} from "@shared/auth-side-nav/auth-side-nav.component";
import {DataService} from "@shared/services/data.service";
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { HeaderComponent } from './layout/header/header.component';
import {PaginationComponent} from "@shared/pagination/pagination.component";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ExportCsvModalComponent} from "@shared/export-csv-modal/export-csv-modal.component";
import {ExportCsvComponent} from "@shared/export-csv/export-csv.component";
import {IconAssetComponent} from "@shared/icon-asset/icon-asset.component";
import {SelectComponent} from "@shared/select/select.component";
import {DatePickerComponent} from "@shared/date-picker/date-picker.component";
import {NavigationService} from "@shared/services/navigation-service.service";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {BackButtonDirective} from "@shared/directives/back-button.directive";
import {DragDropDirective} from "@shared/directives/dragDrop.directive";
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { RedeemModalComponent } from './redeem-modal/redeem-modal.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [
    AuthSideNavComponent,
    SidebarComponent,
    HeaderComponent,
    PaginationComponent,
    ExportCsvModalComponent,
    ExportCsvComponent,
    IconAssetComponent,
    SelectComponent,
    DatePickerComponent,
    BackButtonDirective,
    DragDropDirective,
    ConfirmDialogComponent,
    RedeemModalComponent
  ],
  providers: [
    DataService,
    NavigationService

  ],
  exports: [
    CommonModule,
    FormsModule,
    AuthSideNavComponent,
    SidebarComponent,
    HeaderComponent,
    PaginationComponent,
    ExportCsvModalComponent,
    ExportCsvComponent,
    IconAssetComponent,
    DatePickerComponent,
    SelectComponent,
    BackButtonDirective,
    DragDropDirective,
    ConfirmDialogComponent,
    RedeemModalComponent,
    TranslateModule,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbModule,
    // NgxIntlTelInputModule,
    ModalModule.forRoot(),
    TranslateModule,
    FontAwesomeModule,
    BsDatepickerModule,
    NgxSpinnerModule
  ]
})
export class SharedModule {
}
